module.exports = __webpack_public_path__ + "fe41d4c208f9483b7958be138a4756a9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/review.svg
// module id = 445
// module chunks = 0